import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';

@Injectable({
  providedIn: 'root'
})
export class VmiRefrescamientoTanquesService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.refrescamientoTanque);
  }

  create(innObj: any): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.refrescamientoTanque, innObj);
  }

  edit(innObj: any): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.refrescamientoTanque, innObj);
  }

  delete(innIdObj: string): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.refrescamientoTanque + `/${innIdObj}`);
  }
}
